import { FormGroup } from '@angular/forms';
import {
  ColumnEditorModel,
  CriteriaSortEnum,
  FieldJunctionEnum,
  ResultTypeEnum,
  SearchCriteriaDtoModel,
  SearchDtoModel,
  SearchSortDtoModel,
  SortDtoModel
} from '@bo-client/shared/dynamic-search-serverside/dynamic-search.model';
import { Injectable } from '@angular/core';
import { ConfigColumnsFeederContractConst } from '@bo-client/activation-management/feeder-contract/feeder-contract-list/columns-definition-feeder-contract.model';

@Injectable()
export class ListService {
  initSearchSortDto(
    hasBackOfficeSettings: boolean,
    filterForm: FormGroup,
    columns: ColumnEditorModel[],
    listColumnsDefinition: any[]
  ): SearchSortDtoModel {
    let searchSortDto = new SearchSortDtoModel();

    const searchDto = new SearchDtoModel();
    const sorts: Array<SortDtoModel> = new Array<SortDtoModel>();
    const initialIdDescFilter: SortDtoModel = new SortDtoModel();
    initialIdDescFilter.fieldName = 'id';
    initialIdDescFilter.direction = CriteriaSortEnum.DESC;
    sorts.push(initialIdDescFilter);

    searchSortDto.searchDto = searchDto;
    searchSortDto.sorts = sorts;

    searchDto.resultType = ResultTypeEnum.OrderRequest; // TODO: warum gibt es diesen Returntype und was tut er?

    if (hasBackOfficeSettings) {
      searchSortDto = this.refreshFilters(filterForm, searchSortDto, listColumnsDefinition);

      const idxColumn = columns.findIndex((x) => x.isSort);
      if (idxColumn > -1) {
        sorts[0].fieldName = columns[idxColumn].id;
        sorts[0].direction = columns[idxColumn].criteriaSort;
      }
    }
    return searchSortDto;
  }

  refreshFilters(
    form: FormGroup,
    searchSortDto: SearchSortDtoModel,
    listColumnsDefinition: any[]
  ): SearchSortDtoModel {
    const listSearchCriteriaDto: Array<SearchCriteriaDtoModel> = new Array<SearchCriteriaDtoModel>();
    listColumnsDefinition.forEach((ele) => {
      if (ele.formField) {
        const value = form.controls[ele.id].value;
        if (value != '') {
          const searchCriteria: SearchCriteriaDtoModel = new SearchCriteriaDtoModel();
          searchCriteria.fieldName = ele.id;
          searchCriteria.operation = ele.searchCriteria;
          searchCriteria.fieldJunction = FieldJunctionEnum.AND;
          searchCriteria.fieldType = ele.fieldType;
          searchCriteria.nestedField = ele.nestedField;
          searchCriteria.nestedPath = ele.nestedPath;
          switch (ele.fieldType) {
            case 'MULTISELECTIN':
              searchCriteria.filterValue = 'multiselect';
              const values = [];
              value.forEach((e) => values.push(e.value));
              searchCriteria.multiFilterValues = values;
              break;
            case 'JOIN':
              if (ele.id == 'user') {
                /*
                 todo Michael GC set dropdown with of ng-select auto
                 if (value == null) {
                   searchCriteria.filterValue = "";
                 } else {
                   searchCriteria.filterValue = value.displayName;
                 }*/
                searchCriteria.filterValue = value;
              }
              if (ele.id == 'activities') {
                searchCriteria.filterValue = value;
              }
              break;
            default:
              searchCriteria.filterValue = value;
              break;
          }
          listSearchCriteriaDto.push(searchCriteria);
        }
      }
    });
    searchSortDto.searchDto.filters = listSearchCriteriaDto;
    return searchSortDto;
  }

  initFilters(
    storedColumnConfig: any,
    filterForm: FormGroup,
    listColumnsDefinition: any[]
  ): SearchSortDtoModel {
    let searchSortDto = new SearchSortDtoModel();
    searchSortDto.searchDto = new SearchDtoModel();
    searchSortDto.sorts = [{ fieldName: 'id', direction: CriteriaSortEnum.DESC }];
    const hasBackEndSettings =
      storedColumnConfig && storedColumnConfig.length > 0 && storedColumnConfig[0].initValue !== undefined;
    if (hasBackEndSettings) {
      searchSortDto = this.refreshFilters(filterForm, searchSortDto, listColumnsDefinition);
    }
    return searchSortDto;
  }
}
